// Data transformation utilities

export function log2p1(x) {
  return Math.log2((x || 0) + 1);
}

export function zScore(values) {
  const n = values.length;
  if (n === 0) return [];
  const mean = values.reduce((a, b) => a + b, 0) / n;
  const std = Math.sqrt(values.reduce((a, b) => a + (b - mean) ** 2, 0) / (n - 1)) || 1;
  return values.map(v => Math.max(-3, Math.min(3, (v - mean) / std)));
}

export function zScoreMatrix(matrix) {
  // matrix: array of rows, each row is array of values
  // returns same shape with z-scores per row
  return matrix.map(row => zScore(row.map(log2p1)));
}
